export default ({ environmentList, origin }) =>
  environmentList.filter(({ value }) => value !== origin);



// WEBPACK FOOTER //
// ./client/helpers/get-environment-list.js